import { VIEW } from 'interfaces';
import { useMatch } from 'react-router-dom';

export const useCurrentView = () => {
    const match = useMatch(`/:view`);
    const currentView: VIEW = match?.params?.view as VIEW;
    return currentView;
};
